// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"d9316b4c","115":"396ab34e","424":"032002e6","455":"935c77ce","546":"919f3032","776":"a734692b","869":"de766212","977":"bf899e87"}[chunkId] + ".chunk.js";
};